const amountOfTaskMessageTemplatesOnPage = 20;

export default amountOfTaskMessageTemplatesOnPage;
